/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment } from 'react';

import useMeetApprovedRequestApproval from './UseMeetApprovedRequestApproval';

import WorkFlowNavigation from '../components/navigation/WorkFlowNavigation';
import LocalConstants from '../../../Constants';

import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import ReadOnly from '@usas/ui-web/components/readOnly/ReadOnly';
import ActionIntraPageButton from '@usas/ui-web/components/buttons/ActionIntraPageButton';
import Input from '@usas/ui-web/components/inputs/Input';
import ViewReport from '@usas/ui-web/components/embeddedReports/ViewReport';

import { formatDate } from '@usas/ui-web/utils/DateFunctions';

const MeetApprovedRequestApproval = () => {
  const {
    location,
    Constants,
    isLoading,
    isSaving,
    hasMeetAnnouncement,
    meetApprovedRequestState,
    meetApprovedRequestObjState,
    viewState,
    setViewState,
    INITIAL_VIEW_STATE,
    onBackClicked,
    onApprovedClicked,
    onRejectClicked,
    onDownloadUploadedFile,
    onViewReportClicked,
    formState,
    errorState,
    onFormValueChanged
  } = useMeetApprovedRequestApproval();

  return (
    <div className="row">
      <WorkFlowNavigation headerTitle={"Approved Meet Request" + `${location.state?.isRevisit === true ? ' - Revisit' : ' - New Request'}`}>
        {meetApprovedRequestState.isObjLoaded === true &&
          <form noValidate>
            <div className="row">
              <div className="col-xs-12 col-sm-6 col-sm-push-6">
                <ActionIntraPageButton type="button" className="pull-right" onClick={onViewReportClicked}>
                  View Report
                </ActionIntraPageButton>
                {hasMeetAnnouncement === true &&
                  <ActionIntraPageButton type="button" className="pull-right" onClick={onDownloadUploadedFile}>
                    Download Meet Announcement
                  </ActionIntraPageButton>
                }
              </div>
              <div className="col-xs-12 col-sm-6 col-sm-pull-6">
                <ReadOnly
                  label="LSC - Club Name/Club Code: "
                  name="lscClubNameCode"
                  value={`${meetApprovedRequestObjState.lscCode || ''} - ${meetApprovedRequestObjState.clubName || ''}/${meetApprovedRequestObjState.clubCode || ''}`} />
              </div>
              <div className="col-xs-12">
                <ReadOnly
                  label="Submission Date: "
                  name="submissionDate"
                  value={formatDate(meetApprovedRequestObjState.submissionDate)} />
              </div>
            </div>
            <div className="row usas-extra-top-margin">
              <div className="col-xs-12 col-sm-6">
                {location.state?.isRevisit === true ?
                  <ReadOnly
                    label="Meet Name: "
                    name="meetName"
                    value={formState.meetName} />
                  :
                  <Input
                    label="Meet Name*"
                    value={formState.meetName}
                    error={errorState.meetName}
                    message={errorState.meetName}
                    name='meetName'
                    onChange={value => onFormValueChanged('meetName', value)} />}
              </div>
              <div className="col-xs-12 col-sm-6">
                <ReadOnly
                  label="Meet Dates: "
                  name="meetDates"
                  value={`${formatDate(meetApprovedRequestObjState.meetStartDate)} - ${formatDate(meetApprovedRequestObjState.meetEndDate)}`} />
              </div>
            </div>
            <div className="row usas-extra-top-margin">
              <div className="col-xs-12 col-sm-6">
                <ReadOnly
                  label="Meet Classification: "
                  name="meetClassification"
                  value={meetApprovedRequestObjState.meetClassification} />
              </div>
              <div className="col-xs-12 col-sm-6">
                <ReadOnly
                  label="Meet Type: "
                  name="meetType"
                  value={meetApprovedRequestObjState.meetType} />
              </div>
            </div>
            <div className="row usas-extra-top-margin">
              <div className="col-xs-12 col-sm-6">
                {location.state?.isRevisit === true ?
                  <ReadOnly
                    label="Sanction Number*"
                    name="meetSanctionNumber"
                    value={formState.meetSanctionNumber}
                  />
                  :
                  <Input
                    label="Sanction Number*"
                    value={formState.meetSanctionNumber}
                    error={errorState.meetSanctionNumber}
                    message={errorState.meetSanctionNumber}
                    name='meetSanctionNumber'
                    onChange={value => onFormValueChanged('meetSanctionNumber', value)} />}
              </div>
            </div>
            <div className="row usas-extra-top-margin usas-extra-bottom-margin">
              <div className="col-xs-12 usas-extra-top-margin">
                {location.state?.isRevisit === false && <Fragment><PrimaryButton type="button" onClick={onApprovedClicked}>Approve</PrimaryButton>&nbsp;</Fragment>}
                <SecondaryButton type="button" onClick={onBackClicked}>Back</SecondaryButton>&nbsp;
                {location.state?.isRevisit === false && <Fragment><PrimaryButton type="button" onClick={onRejectClicked}>Reject</PrimaryButton></Fragment>}
              </div>
            </div>
          </form>
        }
      </WorkFlowNavigation>
      {viewState.showReport === true &&
        <ViewReport reportInfoId={viewState.reportInfoId} reportParameters={viewState.reportParameters} onBackToGrid={() => setViewState(INITIAL_VIEW_STATE)} />}
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={isLoading} />
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.SAVING_MSG}
        displayPopUp={isSaving} />
    </div>
  );
};

export default MeetApprovedRequestApproval;